import { FC } from "react";
import { SanityInfoPage } from "../../graphql-types";
import { cn } from "../lib/helpers";
import * as styles from "./Schedule.module.scss";
import { pageSubtitleStyle, pageTitleStyle } from "./typography.module.scss";

export type ScheduleProps = Pick<SanityInfoPage, "scheduleTitle" | "schedules">;
const Schedule: FC<ScheduleProps> = ({ scheduleTitle, schedules }) => {
  return (
    <div id="schedule" className={styles.root}>
      <div className={cn(pageTitleStyle, styles.title)}>{scheduleTitle}</div>
      {schedules.map((schedule) => (
        <div className={styles.schedule} key={schedule.title}>
          <div className={cn(pageSubtitleStyle, styles.subtitle)}>
            {schedule.title}
          </div>
          <ol className={styles.scheduleList}>
            {schedule.scheduleItems.map((item) => (
              <li
                className={styles.scheduleItem}
                key={`${item.time}_${item.text}`}
              >
                <div className={styles.itemTime}>{item.time}</div>
                <div className={styles.itemText}>{item.text}</div>
              </li>
            ))}
          </ol>
        </div>
      ))}
    </div>
  );
};

export default Schedule;
